module.exports = __webpack_public_path__ + "static/media/logo2.3537a778.png";